import { AuthContextType } from '@/types';

const isMockAuth = import.meta.env.VITE_AUTH_MOCK === 'true';

let _useAuth: () => AuthContextType;

if (isMockAuth) {
  const { useMockAuth } = await import('./MockAuthProvider');
  _useAuth = useMockAuth;
} else {
  const { useAuth } = await import('./AuthContext');
  _useAuth = useAuth;
}

export const useAuth = _useAuth;
